export default {
	title: 'संकेतक',
	url: 'indicators',
	subtitle:
		"अपने सफलता संकेतकों को सूचीबद्ध करें और उन्हें श्रेणियों में व्यवस्थित करें — डिफ़ॉल्ट रूप से बैलेंस्ड स्कोरकार्ड के 4 दृष्टिकोण: वित्तीय, ग्राहक, आंतरिक प्रक्रियाएँ, सीखना और विकास। विज़ुअलाइज़ेशन टैब उन्हें परिदृश्य-दर-परिदृश्य विकास के साथ स्कोरकार्ड के रूप में प्रस्तुत करता है।",
	no_description: 'कोई संकेतक परिभाषित नहीं',
	context_worse: 'नकारात्मक',
	context_best: 'सकारात्मक',
	tabs: {
		filters: {
			title: 'दृश्य फ़िल्टर'
		},
		general: {
			title: 'सामान्य'
		},
		export: {
			title: 'निर्यात'
		},
		comments: {
			title: 'इतिहास'
		},
		bot: {
			title: 'बुद्धिमत्ता'
		}
	},
	messages: {
		edit_constraint: 'संकेतक संपादन',
		create_constraint: 'नया संकेतक बनाएँ'
	},
	onboarding: {
		title: 'संकेतकों की समीक्षा',
		description:
			"जाँच करें कि संकेतक बैलेंस्ड स्कोरकार्ड की श्रेणियों को कवर करते हैं और कार्य योजना से जुड़े हैं।"
	}
};
